import { render, staticRenderFns } from "./VueTableDynamic.vue?vue&type=template&id=4c13b0be&scoped=true&"
import script from "./VueTableDynamic.vue?vue&type=script&lang=js&"
export * from "./VueTableDynamic.vue?vue&type=script&lang=js&"
import style0 from "./VueTableDynamic.vue?vue&type=style&index=0&id=4c13b0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13b0be",
  null
  
)

export default component.exports